"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'If you pass the <code class="inline">flat</code> prop, it will look like minimalist. ' +
    'When clicked, it will reveal a background color.';
var code = "import React from 'react';\nimport { Button } from 'jsc-react-ui';\n\nconst ButtonExample = () => <Button flat />;";
exports.FlatExampleButton = function () { return (React.createElement(common_1.Example, { title: "Flat", description: description, code: code },
    React.createElement(components_1.Button, { flat: true }))); };
exports.FlatExampleButton.displayName = 'FlatExampleButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/FlatExampleButton.tsx
// module id = 635
// module chunks = 0